module.exports = __webpack_public_path__ + "img/cfdaf2734d1c75f4b11fbafcda8fa5c5.451db98d.png";